import entries from './entries';
import files from './files';
import login from './login';
import tags from './tags';
import tagSets from './tagSets';
import templates from './templates';
import headlines from './headlines';
import emailBlocks from './emailBlocks';
import categories from './categories';
import brandLibrary from './brandLibrary';
import brandAssets from './brandAssets';
import designAssets from './designAssets';
import componentState from './componentState';
import customers from './customers';
import listingBanners from './listingBanners';
import kvstore from './kvstore';
import emailEditor from './emailEditor';
import presets from './presets';
import views from './views';

export default {
	entries,
	files,
	login,
	tags,
	tagSets,
	templates,
	headlines,
	emailBlocks,
	categories,
	brandLibrary,
	brandAssets,
	designAssets,
	componentState,
	customers,
	listingBanners,
	kvstore,
	emailEditor,
	presets,
	views,
};
